module.exports = __webpack_public_path__ + "static/media/tecumseh.99ee97f6.png";